// extracted by mini-css-extract-plugin
module.exports =  {"container":"_93444fe79c--container--D8mQd","content":"_93444fe79c--content--eTJ5Z"};